 <template lang="html">
  <div id="reservationPopup" :style="getStyle" class="fontinfo effect1">
  <span style="font-size: 18px; margin-bottom: 15px;">予約</span>
  <button @click="closePopup">x</button>
  <form
  id="reservationForm"
  @mousedown.stop
  @mouseup.stop
  @mousemove.stop
  >
  <table
  :class="{errorDuplication: isSomeDuplicatedReservation}"
  :title="isSomeDuplicatedReservation ? '同時間帯に同じ講義が存在します' : ''" id="timeinfo">
    <tr>
      <td><span>開始: </span></td>
      <td class="timeinput"><time-select
      :value="$store.state.previewBox.start"
      :picker-options="{
        start: '10:00',
        end: '23:00',
        step: '00:05',
        }" @input="updateStartTime"></time-select>
      </td>
    </tr>
    <tr>
      <td><span>終了: </span></td>
      <td class="timeinput">
        <time-select :value="$store.state.previewBox.end"
        :picker-options="{
          start: '10:00',
          end: '23:00',
          step: '00:05',
          minTime: $store.state.previewBox.start
          }" @input="updateEndTime"></time-select>
        </td>
    </tr>
  </table>

  <div>
    <div v-if="$store.state.userInfo.user_type === 'student'">
      <label id="type">授業の種類：
        <br>
        <input type="radio" id="radioNormal" value="通常" v-model="type">
        <label for="radioNormal">通常授業</label>
        <input type="radio" id="radioNormalFirst" value="通常初回" v-model="type">
        <label for="radioNormalFirst">通常初回授業</label>
        <input type="radio" id="radioShort" value="短期" v-model="type">
        <label for="radioShort">短期講座</label>
      </label>
    </div>
    <div v-if="$store.state.userInfo.user_type === 'teacher' || $store.state.userInfo.user_type === 'admin'">
      <label id="type">授業の種類：
        <br>
        <input type="radio" id="radioNormal" value="通常" v-model="type">
        <label for="radioNormal">通常授業</label>
        <input type="radio" id="radioNormalFirst" value="通常初回" v-model="type">
        <label for="radioNormalFirst">通常初回授業</label>
        <input type="radio" id="radioTrial" value="体験" v-model="type">
        <label for="radioTrial">体験授業</label> <br>
        <input type="radio" id="radioShort" value="短期" v-model="type">
        <label for="radioShort">短期講座</label>
        <input type="radio" id="radioShortFirst" value="短期初回" v-model="type">
        <label for="radioShortFirst">短期初回講座</label>
      </label>
    </div>
  </div>
  <template v-if="!isTanki">
    <div class="nameinput">
      <span>生徒のお名前：</span>
      <template v-if="$store.state.userInfo.user_type === 'student'">
        <input type="text" :value="$store.state.userInfo.fullname" readonly />
        <input type="text" hidden :value="setHiddenID()" />
      </template>
      <template v-else-if="$store.state.userInfo.user_type === 'teacher'">
        <autocomplete :type="'student'" v-model="student" :suggestions="getStudentList()" :placeholder="'生徒のお名前'"></autocomplete>
      </template>
      <template v-else><!-- admin の場合-->
        <autocomplete :type="'admin'" v-model="student" :suggestions="getStudentList()" :placeholder="'生徒のお名前'"></autocomplete>
      </template>
    </div>
    <div class="nameinput">
      <span>先生のお名前：</span>
      <template v-if="$store.state.userInfo.user_type === 'teacher'">
        <input type="text" :value="$store.state.userInfo.fullname" readonly />
        <input type="text" hidden :value="setHiddenID()" />
      </template>
      <template v-else-if="$store.state.userInfo.user_type === 'student'">
        <autocomplete :type="'teacher'" v-model="teacher" :suggestions="getTeacherList()" :placeholder="'先生のお名前'"></autocomplete>
      </template>
      <template v-else><!-- admin の場合 -->
         <autocomplete :type="'admin'" v-model="teacher" :suggestions="getTeacherList()" :placeholder="'先生のお名前'"></autocomplete>
       </template>
    </div>
  </template>
    <template v-if="!isTanki">
      <div style="margin-top: 13px;" class="nameinput">
        <label id="hasTest">配布物（確認テスト等）: <select v-model="hasTest" >
          <option :value="true">
            有り
          </option>
          <option :value="false">
            無し
          </option>
        </select></label>
      </div>
      <input type="checkbox" v-model="isOnline" /> オンライン授業</input>
      <textarea id="message" v-model="message" placeholder="連絡事項" class="message_area"></textarea>

      <input type="button" @click="takeReservation" value="予約をする"
      :disabled="!canTakeResv"/>
      <label v-if="type=='通常'||'短期'"><input type="checkbox" v-model="isRecurrent" />月末まで毎週予約する</label>
      <recurrent-panel v-if="isRecurrent"></recurrent-panel>
    </template>
    <template v-if="isTanki">
      <temporaryLecturePanel :teacher="teacher" :reservationType="type">
        <span>先生のお名前：</span>
        <template v-if="$store.state.userInfo.user_type === 'teacher'">
          <input type="text" :value="$store.state.userInfo.fullname" readonly />
          <input type="text" hidden :value="setHiddenID()" />
        </template>
        <template v-else-if="$store.state.userInfo.user_type === 'student'">
          <autocomplete :type="'teacher'" v-model="teacher" :suggestions="getTeacherList()" :placeholder="'先生のお名前'"></autocomplete>
        </template>
        <template v-else><!-- admin の場合 -->
           <autocomplete :type="'admin'" v-model="teacher" :suggestions="getTeacherList()" :placeholder="'先生のお名前'"></autocomplete>
         </template>
      </temporaryLecturePanel>
    </template>
  </form>
  </div>
</template>

<script>
import { TimeSelect } from 'element-ui'
import 'element-ui/lib/theme-chalk/time-select.css'
import RecurrentReservePanel from './RecurrentReservePanel.vue'
import AutocompleteSelection from './AutocompleteSelection'
import TemporaryLecturePanel from './TemporaryLecturePanel.vue'
// import T from '@/modules/time'

import {
  PREVIEWBOX_TIME_UPDATE,
  PREVIEWBOX_HIDE_POPUP,
  SPINNER_SHOW,
  SPINNER_HIDE
} from '@/vuex/mutation_types'
import {
  mapGetters,
  mapActions
} from 'vuex'

export default {
  components: {
    'time-select': TimeSelect,
    'recurrent-panel': RecurrentReservePanel,
    'autocomplete': AutocompleteSelection,
    'temporaryLecturePanel': TemporaryLecturePanel
  },
  data () {
    return {
      student: this.$store.state.userInfo.user_type === 'student' ? this.$store.state.userInfo.user_id : 0,
      teacher: this.$store.state.userInfo.user_type === 'teacher' ? this.$store.state.userInfo.user_id : 0,
      width: 450,
      isRecurrent: false,
      hasTest: false,
      _isTanki: false,
      type: '通常',
      message: ``,
      isOnline: false
    }
  },
  methods: {
    ...mapActions([
      'getReservations',
      'postReservation',
      'updateUserList',
      'postRecurrentReservations',
      'changeStatus'
    ]),
    updateStartTime (val) {
      this.$store.commit(PREVIEWBOX_TIME_UPDATE,
        { start: val }
      )
    },
    updateEndTime (val) {
      this.$store.commit(PREVIEWBOX_TIME_UPDATE,
        { end: val }
      )
    },
    takeReservation () {
      // 空欄チェック
      if (this.student === 0 || this.teacher === 0) {
        alert('空欄では予約できません')
        return
      }
      // 教室の仕様変更のため307は15時以降の予約を禁止
      if (this.$store.state.previewBox.classroom.match('307')) {
        if (this.$store.state.previewBox.start < '15:00' && this.$store.state.userInfo.user_type !== 'admin') {
          alert('15時以前307教室は使用できません')
          return
        }
      }
      this.$store.commit(SPINNER_SHOW)
      // 必要があればステータス更新
      if (this.type === '通常初回') {
        console.log(this.$store.state)
        let std = this.$store.state.lectureInfo.find((info, index) => {
          return this.student === info.student.id
        })
        console.log(std)
        this.updateStatus(this.student, std.student.id)
      }
      if (!this.isRecurrent) {  // 通常の予約
        this.postReservation({
          student: this.student,
          teacher: this.teacher,
          start_time: this.$store.state.previewBox.start,
          end_time: this.$store.state.previewBox.end,
          classroom: this.$store.state.previewBox.classroom,
          date: this.getCurDateFormated,
          has_test: this.hasTest,
          reservation_type: this.type,
          message: this.message,
          school_id: this.$store.state.userInfo.school_id,
          online: this.isOnline
        }).then(() => {
          // 予約情報を更新
          this.getReservations({
            all: 1,
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
        this.closePopup()
        this.$store.commit(SPINNER_HIDE)
        return
      } else { // 繰り返し予約
        this.postRecurrentReservations({
          student: this.student,
          teacher: this.teacher,
          start_time: this.$store.state.previewBox.start,
          end_time: this.$store.state.previewBox.end,
          classroom: this.$store.state.previewBox.classroom,
          rrule: this.$store.state.recurrentRule,
          has_test: this.hasTest,
          reservation_type: this.type,
          message: this.message,
          school_id: this.$store.state.userInfo.school_id,
          online: this.isOnline
        }).then((res) => {
          console.log(res)
          if (res.data.overlapping_datetimes.length > 0) {
            let message = '次の日付は，重複のため予約に失敗しました．'
            for (let dates of res.data.overlapping_datetimes) {
              message += dates.date + ':(' + dates.start_time + ')〜(' + dates.end_time + '), '
            }
            alert(message)
          }
        }).then(() => {
          // 予約情報を更新
          this.getReservations({
            all: 1,
            date: this.getCurDateFormated,
            school_id: this.$store.state.userInfo.school_id
          })
        })
        this.closePopup()
        this.$store.commit(SPINNER_HIDE)
        return
      }
    },
    closePopup () {
      // popupを閉じる
      this.$store.commit(PREVIEWBOX_HIDE_POPUP)
      // preview box を閉じる
      this.$store.commit(PREVIEWBOX_TIME_UPDATE,
        {
          start: '10:00',
          end: '10:00'
        }
      )
    },
    setHiddenID () {
      if (this.$store.state.userInfo.user_type === 'student') {
        this.student = this.$store.state.userInfo.user_id
      } else if (this.$store.state.userInfo.user_type === 'teacher') {
        this.teacher = this.$store.state.userInfo.user_id
      }
      return this.$store.state.userInfo.user_id
    },
    selectorUpdate (val) {
      console.log(val)
    },
    getTeacherList () {
      // すでに生徒を選んでいる場合
      if (this.student !== 0) {
        return this.$store.state.lectureInfo.filter((lect, index, self) => {
          return this.student === lect.student.id
        }).map((lect, index, self) => {
          return lect.teacher
        })
      }
      // それ以外の場合，教師全体のリストを返す
      if (this.$store.state.userlist.length === 0) {
        this.updateUserList()
      }
      return this.$store.state.userlist.filter((user, index, self) => {
        return (user.user_type === 'teacher')
      })
    },
    getStudentList () {
      // すでに教師を選んでいる場合
      if (this.teacher !== 0) {
        return this.$store.state.lectureInfo.filter((lect, index, self) => {
          // 応急処置として短期ユーザも常に表示するように
          // return this.teacher === lect.teacher.id && !/^tanki_/.test(lect.student.user_name)
          return this.teacher === lect.teacher.id
        }).map((lect, index, self) => {
          return lect.student
        })
      }
      // それ以外の場合，生徒全体のリストを返す
      if (this.$store.state.userlist.length === 0) {
        this.updateUserList()
      }
      return this.$store.state.userlist.filter((user, index, self) => {
        // 応急処置として短期ユーザも常に表示するように
        // return user.user_type === 'student' && !/^tanki_/.test(user.user_name)
        return (user.user_type === 'student' && user.school_id === Number(this.$store.state.userInfo.school_id))
      })
    },
    updateStatus (id, status) {
      var newStatus = 'normal'
      switch (status) {
        case 'temporal':
        case 'temp/temp':
        case 'temp/norm':
          newStatus = 'temp/norm'
          break
        case 'trial':
          newStatus = 'normal'
          break
      }
      this.changeStatus({
        id: id,
        newStatus: newStatus
      })
    }
  },
  computed: {
    ...mapGetters([
      'tableWidth',
      'timelineHeight',
      'getCurDateFormated',
      'reservationsInRange'
    ]),
    isTanki: {
      get () {
        return this.type !== '通常' && this.type !== '通常初回' && this.type !== '短期'
      },
      set (value) {
        this._isTanki = value
      }
    },
    getStyle () {
      let style = {
        width: this.width + 'px',
        'z-index': 1100
      }
      const s = this.$store.state.previewBox.style
      // previewBoxの位置によって位置を変更
      if (s.left < this.tableWidth / 2) {
        // 左側半分にあるときは previewBox の右側に表示
        style.left = (s.left + this.$store.state.columnWidth) + 'px'
        style.right = undefined
      } else {
        // 右半分にあるときは previewBox の左側
        style.left = (s.left - this.width - 5) + 'px'
      }
      if (s.top < this.timelineHeight / 2) {
        // 上半分にあるときは previewBox の上端に追従
        style.top = s.top + 'px'
        style.bottom = undefined
      } else {
        // 下半分の時は、 previewBox の下端に追従
        style.top = (s.top) + 'px'
      }
      return style
    },
    canTakeResv () { // 予約するボタンの disable 属性の可否
      // 生徒か教師が未選択
      if (this.teacher === 0 || this.student === 0) {
        return false
      }
      // 重複の有無
      if (this.isSomeDuplicatedReservation) {
        return false
      }

      return true
    },
    isSomeDuplicatedReservation () {
      return this.reservationsInRange(
        this.$store.state.previewBox.start,
        this.$store.state.previewBox.end
      ).some((elem, index, self) => {
        return (elem.teacher.id === this.teacher ||
        elem.student.id === this.student)
      })
    }
  }
}

</script>

<style lang="css"  scoped>
#reservationPopup {
  position: absolute;
  margin: 0px 5px 0px;
  background-color: white;
  border-radius: 5px;
  border-style: solid;
  border-color: #0065B3;
  padding: 10px 5px 10px;

  z-index: 1002;
}
#reservationForm {
  text-align: left;
  padding: 10px 10px 5px 10px;
  margin: auto;
}
#reservationType, #hasTest, #message {
  display: block;
}
button {
  float: right;
  border: none;
  color: white;
  margin-right: 5px;
  background-color: #ffd500;
}
button:hover {
  opacity: 0.5;
}
#message {
  width: 90%;
}
.errorDuplication { /* 同一ユーザーの同一時間での予約の重複がある */
  background-color: #ffcccc;
}
.timeinput {
  padding-left: 13px;
}
.fontinfo {
  font-family: "メイリオ", "ヒラギノ丸ゴ ProN", sans-serif;
  color: #5B5B5B;
}
#timeinfo {
  font-size: 16px;
}
.classtype {
  font-size: 16px;
}
.nameinput {
    font-size: 16px;
}
.square_btn {
    margin-top: 13px;
    font-size: 14px;
    position: relative;
    display: inline-block;
    padding: 0.25em 0.5em;
    text-decoration: none;
    color: #FFF;
    background: #FFCC33;/*背景色*/
    border-bottom: solid 2px #d27d00;/*少し濃い目の色に*/
    border-radius: 4px;/*角の丸み*/
    box-shadow: inset 0 2px 0 rgba(255,255,255,0.2), 0 2px 2px rgba(0, 0, 0, 0.19);
}
.square_btn:active {
    border-bottom: solid 2px #fd9535;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.30);
}
.message_area {
  border:0;
  font-size:15px;
  color:#505050;
  border:solid 1px #ccc;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  margin-top: 5px;
}
.effect1{
    -webkit-box-shadow: 0 5px 20px #6A6A6A;
       -moz-box-shadow: 0 5px 20px #6A6A6A;
            box-shadow: 0 5px 20px #6A6A6A;
}
</style>



// WEBPACK FOOTER //
// ReservationPopup.vue?a2bc7d80